import {getValueCeiling} from '../../../helpers/get-value-ceiling.js'

export function getPpChanges(action, combatantMap, currentCombatantStateChanges, combatantModels) {

  //Copy the changes.
  let changes = {
    ...currentCombatantStateChanges
  };


  //Add stuff to the changes
  if (action.ppCost > 0) {
    const casterModel = combatantModels[combatantMap.casterId];

    //Apply the new value to state
    changes.state[combatantMap.casterId].pp = casterModel.pp - action.ppCost;
  }


  //PP Increase (Ex: Mini PP Pack. Note: This would wipe out any changes from ppCost^^)
  if (action.affectTargetPpPoints !== 0) {

    combatantMap.targetIds.forEach(targetId => {
      const targetModel = combatantModels[targetId];
      const initialPpValue = targetModel.pp;
      const newPpValue = getValueCeiling(
        initialPpValue + action.affectTargetPpPoints,
        targetModel.maxPp
      );

      //Set the new PP value
      changes.state[combatantMap.casterId].pp = newPpValue;

      //Track the change from Old to New
      changes.description.ppDiff = changes.description.ppDiff || {};
      changes.description.ppDiff[targetId] = newPpValue - initialPpValue;

    });


  }


  return changes;
}


// WEBPACK FOOTER //
// ./src/battle/lifecycle/description/pp.js